<template>
  <div>
    <!-- Add -->
    <v-dialog width="1220" persistent v-model="dialog" scrollable>
      <v-card>
        <v-card-title style="font-size: 25px; height: 75px" class="pb-4">
          <v-icon style="color: #363636" class="mr-1"
            >mdi-circle-edit-outline</v-icon
          >
          {{ $t("editknowledgesharing") }}
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              $emit('close'),
                (departmentSelected = []),
                (userSelected = []),
                $refs.form.reset(),
                DeletePDFfile()
            "
            color="#424242"
            style="
              border-radius: 8px !important;
              border: 1px solid rgba(66, 66, 66, 0.05);
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text style="height: 800px">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row class="mt-5">
              <v-col>
                <v-row>
                  <v-col cols="12">
                    <label for="title" class="font-style"
                      >{{ $t("title") }}
                      <span style="color: red">*</span></label
                    >
                    <v-text-field
                      :rules="titleRules"
                      outlined
                      dense
                      hide-details="auto"
                      id="title"
                      v-model="editLessonLearnData.caseTitle"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <label for="description" class="font-style">{{
                      $t("description")
                    }}</label>
                    <v-text-field
                      outlined
                      dense
                      hide-details="auto"
                      id="description"
                      v-model="editLessonLearnData.caseDescription"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <label for="startDate" class="font-style">{{
                      $t("startdate")
                    }}</label>
                    <v-menu
                      v-model="startDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="rounded-lg"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          outlined
                          dense
                          hide-details="auto"
                          id="startDate"
                          prepend-inner-icon="mdi-calendar-blank-outline"
                          v-model="editStartDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="secondary"
                        :allowed-dates="allowedStartDates"
                        v-model="editStartDate"
                        @input="editstartdateDis()"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-progress-circular
                    v-if="loading"
                    indeterminate
                    class="loading-circle"
                    color="green"
                  ></v-progress-circular>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <label for="endDate" class="font-style">{{
                      $t("enddate")
                    }}</label>
                    <v-menu
                      v-model="endDateMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          class="rounded-lg"
                          v-bind="attrs"
                          v-on="on"
                          readonly
                          outlined
                          dense
                          hide-details="auto"
                          id="endDate"
                          prepend-inner-icon="mdi-calendar-blank-outline"
                          v-model="editEndDate"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="secondary"
                        :allowed-dates="allowedEndDates"
                        v-model="editEndDate"
                        @input="endDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="7">
                    <p
                      class="text-left font-style"
                      :style="fileError ? { color: 'red' } : {}"
                    >
                      {{ $t("imagecover") }}
                    </p>
                    <div class="drop">
                      <v-card
                        width="290"
                        height="215"
                        style="
                          border: 2px dashed #c0c0c0;
                          box-shadow: unset;
                          background: #f8f8f8 0% 0% no-repeat padding-box;
                        "
                        @click="$refs.file.click()"
                        @dragover.prevent
                        @dragenter.prevent
                        @drop.prevent="dropImg($event)"
                      >
                        <v-img
                          :src="editLessonLearnData.caseImage"
                          @click="$refs.file.click()"
                          @mouseover="
                            editLessonLearnData.caseImage
                              ? (showEditImgTool = true)
                              : (showEditImgTool = false)
                          "
                          @mouseleave="
                            editLessonLearnData.caseImage
                              ? (showEditImgTool = false)
                              : (showEditImgTool = false)
                          "
                          :style="
                            fileError ? { border: '1px solid #FA5252' } : {}
                          "
                          width="240"
                          height="167"
                          style="border-radius: 8px !important"
                          class="mx-auto center mt-4"
                          v-if="editLessonLearnData.caseImage != null"
                        >
                          <v-card-title
                            v-if="showEditImgTool"
                            style="left: 15%; top: 15%; position: absolute"
                          >
                            <v-list
                              class="d-flex flex-column align-start"
                              style="padding: 0; border-radius: 8px"
                            >
                              <v-list-item class="list-item-padding">
                                <v-btn
                                  color="#424242"
                                  style="font-size: 14px; width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click="previewimg = true"
                                  @click.stop="LessonLearnData.file = null"
                                >
                                  <v-icon left>mdi-eye-outline</v-icon>
                                  {{ $t("preview") }}
                                </v-btn>
                              </v-list-item>

                              <v-list-item class="list-item-padding">
                                <v-btn
                                  color="error"
                                  style="font-size: 14px; width: 100px"
                                  text
                                  class="text-capitalize"
                                  @click.stop="
                                    editLessonLearnData.caseImage = null
                                  "
                                >
                                  <v-icon left>mdi-delete-outline</v-icon>
                                  {{ $t("delete") }}
                                </v-btn>
                              </v-list-item>
                            </v-list>
                          </v-card-title>
                        </v-img>
                        <v-img
                          v-if="editLessonLearnData.caseImage == null"
                          src="@/assets/image_loader.png"
                          width="64"
                          height="52"
                          class="mx-auto center"
                          style="margin-top: 2.5rem"
                          @click="$refs.file.click()"
                        ></v-img>
                        <input
                          type="file"
                          class="d-none"
                          ref="file"
                          accept="image/*"
                          @change="uploadImg($event, 1)"
                        />
                        <p
                          v-show="editLessonLearnData.caseImage == null"
                          class="text-center mt-3"
                          style="
                            color: #424242;
                            font-size: 14px;
                            opacity: 0.6;
                            margin-bottom: 0;
                          "
                        >
                          {{ $t("dragdropfile") }}
                        </p>
                        <p
                          v-show="editLessonLearnData.caseImage == null"
                          class="text-center"
                          style="color: #424242; font-size: 14px; opacity: 0.6"
                        >
                          {{ $t("orbrowsefile") }} JPG"
                        </p>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="5">
                    <v-row>
                      <v-btn
                        color="#A6CC39"
                        style="
                          margin-top: 3rem;
                          float: left;
                          border-radius: 8px;
                          height: 40px;
                        "
                        class="text-capitalize white--text btn_hover_effect"
                        @click="$refs.file.click()"
                      >
                        <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
                        {{ $t("addcover") }}
                      </v-btn>
                      <p
                        class="mt-3 pr-3"
                        style="color: #777777; font-size: 12px"
                      >
                        {{ $t("recommendformatpng") }}
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="12">
                <label for="wordContent" class="font-style">
                  {{ $t("wordcontent") }}
                  <span style="color: red">*</span>
                </label>
                <v-textarea
                  outlined
                  :rules="wordContentRules"
                  no-resize
                  id="wordContent"
                  v-model="editLessonLearnData.wordContent"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <label for="link" class="font-style">{{ $t("link") }}</label>
                <v-text-field
                  outlined
                  dense
                  hide-details="auto"
                  id="link"
                  @input="checkLinkType"
                  v-model="editLessonLearnData.link"
                ></v-text-field>
                <span v-if="notLink" style="color: red; font-size: 13px">{{
                  $t("invalidUrlLink")
                }}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <input
                  type="file"
                  accept="application/pdf"
                  class="d-none"
                  ref="pdffile"
                  @change="getpdfFile($event)"
                />
                <v-btn
                  :disabled="LessonLearnData.PDFButtonDisable"
                  color="#A6CC39"
                  @click="($refs.pdffile.value = null), $refs.pdffile.click()"
                  style="font-size: 13px; border-radius: 8px"
                  class="text-capitalize white--text reset-btn"
                >
                  <v-icon class="mr-2" style="font-size: 18px"
                    >mdi-folder-search-outline</v-icon
                  >
                  {{ $t("browsefile") }}
                </v-btn>
                <label
                  for="browsefiles"
                  style="margin-left: 10px"
                  v-if="
                    editLessonLearnData.pdFfilename != '' ||
                      editLessonLearnData.pdFfilename == null
                  "
                  class="font-style"
                  :change="checkdisabledata(editLessonLearnData.pdFfilename)"
                  >{{ editLessonLearnData.pdFfilename }}</label
                >
                <v-icon
                  @click="DeletePDFfile"
                  width="20"
                  height="20"
                  color="error"
                  v-if="LessonLearnData.PDFButtonDisable"
                  style="cursor: pointer; border: 1px"
                  >mdi-delete</v-icon
                >
                <p class="mt-3 pr-3" style="color: #777777; font-size: 12px">
                  {{ $t("recommendformatpdf") }}
                </p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="mt-3 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            class="text-capitalize btnfont-style"
            text
            outlined
            @click="
              $emit('close'),
                (departmentSelected = []),
                (userSelected = []),
                $refs.form.reset(),
                DeletePDFfile()
            "
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize btnfont-style"
            color="secondary"
            @click="submit()"
            >{{ $t("update") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- preview image -->
    <v-dialog
      v-model="previewimg"
      persistent
      width="1000px"
      height="800px"
      overflow="hidden"
      content-class="elevation-0 preview_class"
    >
      <v-card overflow="hidden" color="transparent">
        <v-card-title style="padding-right: 0 !important">
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="previewimg = false"
            color="#FFFFFF"
            style="border-radius: 8px !important; border: 1px solid #ffffff30"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-img
          width="900px"
          height="500px"
          style="border-radius: 8px; margin: auto"
          :src="editLessonLearnData.caseImage"
        ></v-img>
      </v-card>
    </v-dialog>
    <!-- cropimage -->
    <v-dialog
      v-model="dialogCrop"
      persistent
      width="1000px"
      height="800px"
      overflow="hidden"
    >
      <v-card class="rounded-lg" overflow="hidden">
        <v-card-title
          class="white--text pb-4"
          style="background-color: #a6cc39; font-size: 40px"
          >Crop Image</v-card-title
        >
        <v-card-text
          class="pt-12"
          style="height: 550px; padding-left: 4rem; padding-right: 4rem"
        >
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
          ></vue-cropper>
        </v-card-text>
        <v-card-actions class="mt-3 pb-4" style="margin-right: 50px">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="text-capitalize font-style"
            text
            @click="CancelCrop()"
            >{{ $t("cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize font-style reset-btn"
            color="secondary"
            width="80px"
            @click="CropImage()"
            >{{ $t("submit") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Success -->
    <v-dialog v-model="successDialog" width="550">
      <v-card>
        <v-card-title
          style="font-size: 20px; color: #363636; height: 80px"
          class="justify-center"
        >
          <v-icon class="mr-5" style="color: #a6cc39"
            >mdi-checkbox-marked-circle</v-icon
          >
          {{ $t("updateKnowledgesharing") }}
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { mapGetters } from "vuex";
import * as moment from "moment/moment";
import axios from "axios";
import enurl from "@/api/environment";
export default {
  components: {
    VueCropper
  },
  props: {
    show: {
      type: [Boolean, String],
      default: null
    },
    // value: {
    //   type: [String, Array],
    //   required: true,
    //   default: null,
    // },
    fullName: String
  },
  computed: {
    ...mapGetters([
      "editLessonLearnData",
      "showFirstTimeEditDataForLessonLearn"
    ]),
    dialog: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("close");
      }
    },
    editStartDate: {
      get() {
        if (this.editLessonLearnData.startContentDate)
          return this.editLessonLearnData.startContentDate.split("T")[0];
        else return false;
      },
      set(e) {
        this.editLessonLearnData.startContentDate = e;
      }
    },
    editEndDate: {
      get() {
        if (this.editLessonLearnData.startContentDate)
          return this.editLessonLearnData.endContentDate.split("T")[0];
        else return false;
      },
      set(e) {
        this.editLessonLearnData.endContentDate = e;
      }
    },
    titleRules() {
      return [v => !!v || "Title is required"];
    },
    wordContentRules() {
      return [v => !!v || "Word Content is required"];
    },
    isLink() {
      const urlRegex = /^(https?:\/\/(www\.)|(www\.))|(ftp|http(s)?:\/\/).+$/;
      let result;
      if (this.editLessonLearnData.link != null) {
        if (this.editLessonLearnData.link.length != 0) {
          result = urlRegex.test(this.editLessonLearnData.link);
        } else {
          result = true;
        }
      } else {
        result = true;
      }

      return result;
      // Regular expression to check if the input is a valid URL
      // const urlRegex = /^(ftp|http(s)?:\/\/)?(www\.)?[^ "]+$/;
      // const urlRegex = /^(https?:\/\/(www\.)|(www\.))|(ftp|http(s)?:\/\/).+$/;

      // Return true if the input matches the URL pattern, false otherwise
      // return urlRegex.test(this.editLessonLearnData.link);
    }
  },
  data: () => ({
    url: enurl.apiUrl,
    inbox_flag: false,
    pushNoti_flag: false,
    email_flag: false,
    line_flag: false,
    selectedRadio: null,
    notLink: false,
    showEditImgTool: false,
    createdate: moment(new Date().toISOString().substr(0, 10))
      .local()
      .format("DD MMM YYYY"),
    loading: false,
    rules: {
      required: value => !!value || ""
    },
    rulesDate: {
      // required: v => v.length > 11 || '',
      required: v => v.split("-").length > 2 || ""
    },
    selectedList: [],
    dialogCrop: false,
    previewimg: false,
    page: 1,
    pageCount: 0,
    userpage: 1,
    userpageCount: 0,
    deptpage: 1,
    deptpageCount: 0,
    option: {
      img: "",
      size: 1,
      full: false,
      outputType: "png",
      canMove: true,
      fixedBox: true,
      original: false,
      canMoveBox: false,
      autoCrop: true,
      autoCropWidth: 800,
      autoCropHeight: 450,
      centerBox: false,
      high: true
    },
    valid: false,
    successDialog: false,
    LessonLearnData: {
      caseTitle: "",
      caseDescription: "",
      wordContent: "",
      caseImage: "",
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      companyId: localStorage.getItem("companyID"),
      file: null,
      fileName: "",
      fileUrl: "",
      allView: false,
      link: "",
      PDFUrl: "",
      pdffilename: "",
      PDFButtonDisable: false
    },
    isUser: false,
    listDialog: false,
    startDateMenu: false,
    endDateMenu: false,
    userSelected: [],
    departmentSelected: [],
    tabs: "tab-1",
    users: [],
    departments: [],
    userLoading: true,
    departmentLoading: true,
    userLength: 0,
    departmentLength: 0,
    allowedStartDates: val => val >= new Date().toISOString().substr(0, 10),
    fileError: false
  }),

  methods: {
    checkLinkType() {
      if (this.isLink || this.editLessonLearnData.link === "") {
        this.notLink = false;
      } else {
        this.notLink = true;
      }
    },
    checkdisabledata(filename) {
      if (filename != null && filename != "") {
        this.LessonLearnData.PDFButtonDisable = true;
      } else {
        this.LessonLearnData.PDFButtonDisable = false;
      }
    },
    editstartdateDis() {
      let that = this;
      that.startDateMenu = false;
      if (that.editStartDate > that.editEndDate) {
        that.editEndDate = that.editStartDate;
      }
    },
    allowedEndDates(val) {
      return val >= this.editStartDate;
    },
    dropImg(e) {
      let file = e.dataTransfer.files[0];
      if (!/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
        alert("Please choose image!");
        return false;
      }
      this.LessonLearnData.fileName = file.name;
      let reader = new FileReader();
      reader.onload = f => {
        // f.target.result contains the base64 encoding of the image
        let src;
        if (typeof f.target.result === "object") {
          src = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          src = f.target.result;
        }
        this.option.img = src;
        this.dialogCrop = true;
      };
      reader.readAsArrayBuffer(file);
    },
    uploadImg(e, num) {
      let self = this;
      let file = e.target.files[0];
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("Please choose image!");
        return false;
      }
      this.LessonLearnData.fileName = file.name;
      let reader = new FileReader();
      reader.onload = function(f) {
        let data;
        if (typeof f.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([f.target.result]));
        } else {
          data = f.target.result;
        }
        if (num === 1) {
          self.option.img = data;
          self.dialogCrop = true;
        }
      };
      reader.readAsArrayBuffer(file);
    },
    CancelCrop() {
      this.dialogCrop = false;
    },
    CancelPreview() {
      this.previewimg = false;
    },
    CropImage() {
      this.$refs.cropper.getCropData(data => {
        this.getFile(data);
        this.dialogCrop = false;
      });
    },

    checkOrgianlStatus(item) {
      if (item) {
        if (item.includes("T")) {
          return item.split("T")[0];
        } else {
          return item;
        }
      } else {
        return "Date Picker";
      }
    },
    // checkStatus(item) {
    //   if (item.date.length == 0) {
    //     return "Date Picker";
    //   } else if (item.date.length == 1) {
    //     return "Selected Date";
    //   } else {
    //     return "Selected Dates";
    //   }
    // },
    getFile(e) {
      this.LessonLearnData.fileUrl = e;
      this.LessonLearnData.file = e;
      this.editLessonLearnData.caseImage = e;
    },
    async getpdfFile(e) {
      let that = this;
      let file = e.target.files[0];
      if (!/\.pdf$/.test(e.target.value)) {
        alert("Choose PDF files only, please re-select!");
        return false;
      } else {
        that.editLessonLearnData.pdFfilename = file.name;
        that.LessonLearnData.PDFUrl = e;
        that.LessonLearnData.PDFButtonDisable = true;
      }
    },
    DeletePDFfile() {
      let that = this;
      that.editLessonLearnData.pdFfilename = "";
      that.LessonLearnData.PDFUrl = "";
      that.LessonLearnData.PDFButtonDisable = false;
    },
    imageTobase64(fileObject) {
      const reader = new FileReader();
      reader.onload = e => {
        this.LessonLearnData.file = e.target.result;
      };
      reader.readAsDataURL(fileObject);
    },
    async submit() {
      if (this.$refs.form.validate() && this.notLink === false) {
        this.loading = true;
        let permissionList = [];
        if (this.LessonLearnData.PDFUrl != "") {
          let formData = new FormData();
          formData.append("file", this.LessonLearnData.PDFUrl.target.files[0]);
          const res = await axios.post(
            `${this.url}File/UploadPDFFile`,
            formData
          );
          this.LessonLearnData.PDFUrl = res.data.data;
          this.editLessonLearnData.pdffilename = this.LessonLearnData.pdffilename;
        }
        let base64Res = { data: null };
        if (this.LessonLearnData.file) {
          base64Res = await axios.post(`${this.url}File/UploadFileStringBase`, {
            base64: this.LessonLearnData.file,
            fileName: this.LessonLearnData.fileName
          });
        }

        const data = {
          id: this.editLessonLearnData.id,
          permissionData: [],
          wordContent: this.editLessonLearnData.wordContent,
          caseTitle: this.editLessonLearnData.caseTitle,
          endContentDate: this.editLessonLearnData.endContentDate.split("T")[0],
          isUserGroup: this.editLessonLearnData.isUserGroup,
          caseImage: this.LessonLearnData.file
            ? base64Res.data
            : this.editLessonLearnData.caseImage,
          imgBase64: this.LessonLearnData.file
            ? this.LessonLearnData.file
            : this.editLessonLearnData.thumbnail,
          startContentDate: this.editLessonLearnData.startContentDate.split(
            "T"
          )[0],
          companyId: "00000000-0000-0000-0000-000000000000",
          caseDescription: this.editLessonLearnData.caseDescription,
          allView: true,
          link: this.editLessonLearnData.link,
          // imgBase64:this.LessonLearnData.file,
          updateBy: "Admin",
          pdfUrl: this.LessonLearnData.PDFUrl,
          pdfFilename: this.editLessonLearnData.pdFfilename,
          inboxFlag: false,
          emailFlag: false,
          emailLanguage: "eng",
          pushNotiFlag: false,
          lineFlag: false
        };
        console.log("emaildata", data);
        await axios.post(`${this.url}CaseStudies/UpdateCaseStudy`, data);
        this.editLessonLearnData = {
          caseTitle: "",
          caseDescription: "",
          startDate: new Date(
            Date.now() - new Date().getTimezoneOffset() * 60000
          )
            .toISOString()
            .substr(0, 10),
          endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
          wordContent: "",
          file: null,
          fileName: "",
          fileUrl: ""
        };
        this.inbox_flag = false;
        this.email_flag = false;
        this.pushNoti_flag = false;
        this.line_flag = false;
        this.$refs.file.value = null;
        this.$emit("confirm");
        this.successDialog = true;
        this.$refs.form.reset();
        this.DeletePDFfile();
      } else {
        alert("Incomplete information Please enter again!");
      }
      this.loading = false;
    }
  }
};
</script>
<style scoped>
.radio-group {
  display: flex;
  align-items: center;
}
.radiobutton {
  margin-top: -10px;
}
.radio-wrapper {
  position: relative;
  width: 22px;
  height: 22px;
}

.radio-placeholder,
.radio-button {
  position: absolute;
  top: 2px;

  left: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.radio-placeholder {
  background-color: #424242;
  opacity: 0.1;
  pointer-events: none; /* Prevent interaction */
}
.customcardnoti {
  width: 98%;
  margin-left: 10px;
  background-color: #e0e0e0;
}
::v-deep .v-dialog {
  border-radius: 16px !important;
}
::v-deep .v-text-field__slot {
  font-size: 16px !important;
}
.font-style {
  font-size: 16px;
  color: #4d4f5c;
}
.btnfont-style {
  font-size: 16px;
  border-radius: 8px;
}
::v-deep .v-input__slot {
  border-radius: 10px !important;
}
::v-deep .lesson-table tr:nth-child(even) {
  background: #e0e0e0;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 17px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 16px !important;
  color: #47484b !important;
  opacity: 1;
}
::v-deep .accent {
  background-color: #a6cc39 !important;
}
::v-deep .v-tab--active {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
}
::v-deep .v-simple-checkbox .v-icon {
  color: #a6cc39 !important;
}
.loading-circle {
  position: fixed;
  z-index: 5;
  right: 50%;
  bottom: 50%;
  transform: translate(-50%, -50%);
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  /* opacity: 1; */
}

::v-deep .accent--text {
  color: #a6cc39 !important;
}
::v-deep .primary--text {
  color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .primary {
  background-color: #a6cc39 !important;
  border-color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-blank-outline {
  color: #c0c0c0 !important;
}
::v-deep .v-simple-checkbox .mdi-checkbox-marked {
  color: #a6cc39 !important;
}
::v-deep .v-simple-checkbox .mdi-minus-box {
  color: #a6cc39 !important;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>

<style>
.v-text-field__details {
  display: none !important;
}
</style>
